<template>
  <div class="card" style="margin-bottom: 0">
    <div class="card-title">投资人结构</div>
    <div class="wrap">
      <CButtons2 :dButtons1="select_1" :defaultVal="select_1_default" @Cbtns="select1Change" />
      <P10 v-if="select_1_default === '按时间趋势'" ref="p10Ref" />
      <P2 v-if="select_1_default === '按业态对比'" ref="p2Ref" />
      <P3 v-if="select_1_default === '按机构类型'" ref="p3Ref" />
    </div>
  </div>
</template>

<script>
import CButtons2 from '../../Basic/CButtons.vue';
import P10 from './P1-0.vue';
import P2 from './P2.vue';
import P3 from './P3.vue';

export default {
  name: 'Investor',
  components: { CButtons2, P10, P2, P3 },
  data() {
    return {
      select_1: Object.freeze(['按时间趋势', '按业态对比', '按机构类型']),
      select_1_default: '',
    };
  },
  methods: {
    pageInit() {
      this.select_1_default = '按时间趋势';
      setTimeout(() => {
        const ref_name_map = {
          按时间趋势: 'p10Ref',
          按业态对比: 'p2Ref',
          按机构类型: 'p3Ref',
        };
        const n = ref_name_map[this.select_1_default];
        this.$refs[n].resize();
      }, 0);
    },
    select1Change(v) {
      this.select_1_default = v;
    },
  },
};
</script>

<style scoped lang="less">
.card {
  background-color: rgba(29, 31, 37, 1);
  background-color: var(--charts_bgc);
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-top: calc(var(--ROOTFONTFIZE) * (15 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  height: auto;
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  .card-title {
    color: var(--chart_title);
    font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
    font-weight: 700;
    // border-left: 5px solid #1573fe;
    border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
    padding-left: calc(var(--ROOTFONTFIZE) * (10 / 144));
    position: relative;
  }
  .wrap {
    width: 97%;
    margin: auto;
    padding-top: 20px;
    .container {
      margin-left: 0;
    }
  }
}
</style>
